/* global productId, productFormId */
const form = document.getElementById("custom-recharge-form");
// Use a local mutable product id instead of reassigning the read-only global
let currentProductId = typeof productId !== 'undefined' ? parseInt(productId) : null;
const quantityInput = document.getElementById("recharge-quantity");
const quantityElement = document.getElementById("custom-recharge-form-quantity");
const summaryElement = document.getElementById("custom-recharge-form-summary");
const priceElement = document.getElementById("custom-recharge-form-price");
const save_text = document.getElementById("custom-recharge-form-saving")

let config = { childList: true };
let radioContainer = document.getElementById("custom-recharge-form-radios");
let checkedRadio = radioContainer ? radioContainer.querySelector('input[type="radio"]:checked') : null;

let quantity;

const linkedProductsSelect = document.getElementById('linked-product-select');

let targetNode = null;
let select = null;

if(quantityInput){
    quantity = parseInt(quantityInput.value);

    targetNode = document.getElementsByClassName("recharge-subscription-widget")[0].getElementsByTagName("DIV")[0];

    let observer = new MutationObserver(function (mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
                select = targetNode.querySelector('select[name="rc_selling_plan"]');
                if (select) {
                    let options = select.options;
                    radioContainer.innerHTML = "";
    
                    for (let i = 0; i < options.length; i++) { // Création des radio butons en fonction du select Recharge
                        let option = options[i];
    
                        let divWrapper = document.createElement("div");
                        divWrapper.className = "custom-recharge-form-radio"
    
                        let radio = document.createElement("input");
                        radio.type = "radio";
                        radio.name = "selling_plan";
                        radio.value = option.value;
                        radio.setAttribute("form", productFormId);
                        radio.id = "recharge-frequency-" + i;
                        if (i === options.length - 1)
                            radio.checked = true;
                        
                        let label = document.createElement("label");
                        label.innerHTML = option.text + ((i === options.length - 1)? ' (Standard)' : ' (Extra contrôle des odeurs)');
                        label.setAttribute("for", "recharge-frequency-" + i);
    
    
                        divWrapper.appendChild(radio);
                        divWrapper.appendChild(label);
                        radioContainer.appendChild(divWrapper);
                    }
    
                    observer.disconnect();
                }
            }
        }
    });

    observer.observe(targetNode, config);

} else if(linkedProductsSelect){
    quantity = parseInt(linkedProductsSelect.options[linkedProductsSelect.selectedIndex].dataset.nb);
}

// Fonction pour mettre à jour les détails en fonction des inputs
function updateFormDetails() {
    const frequencyInputs = document.querySelectorAll('div[class="custom-recharge-form-radio"]');
    let frequency = "";

    if(quantityInput){
        quantity = parseInt(quantityInput.value);
    } else if(linkedProductsSelect){
        quantity = parseInt(linkedProductsSelect.options[linkedProductsSelect.selectedIndex].dataset.nb);
    }

    frequencyInputs.forEach((input) => {
        const radio = input.querySelector('input');
        const label = input.querySelector('label');
        if (radio && radio.checked) {
            frequency = label.textContent.replace('Livraison', 'livrés');
        }
    });

    // Prix reels du produit lie selectionne (data-* en grosze). Jamais de montant code en dur.
    let unitPrice = null;
    let unitCompare = null;
    if (linkedProductsSelect) {
        const opt = linkedProductsSelect.options[linkedProductsSelect.selectedIndex];
        const nb = parseInt(opt.dataset.nb) || 1;
        const p = parseInt(opt.dataset.price);
        const c = parseInt(opt.dataset.comparePrice);
        if (!isNaN(p)) unitPrice = p / 100 / nb;
        if (!isNaN(c) && c > 0) unitCompare = c / 100 / nb;
    }

    const zl = (n) => n.toFixed(2).replace('.', ',') + ' z\u0142';

    if (unitPrice !== null && priceElement) {
        if (unitCompare && unitCompare > unitPrice) {
            priceElement.innerHTML = `<span class="compare-price">${zl(unitCompare)}</span> ${zl(unitPrice)} za sztuk\u0119`;
            if (save_text) {
                save_text.style.display = "block";
                save_text.textContent = `${Math.round((1 - unitPrice / unitCompare) * 100)}% oszcz\u0119dno\u015bci`;
            }
        } else {
            priceElement.innerHTML = `${zl(unitPrice)} za sztuk\u0119`;
            if (save_text) save_text.style.display = "none";
        }
    }

    // Accord numeral polonais : 1 worek / 2-4 worki / 5+ workow
    const mod10 = quantity % 10;
    const mod100 = quantity % 100;
    const isFew = mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14);
    const worek = quantity === 1 ? 'worek' : (isFew ? 'worki' : 'work\u00f3w');
    const dostarczany = quantity === 1 ? 'dostarczany' : (isFew ? 'dostarczane' : 'dostarczanych');
    const rytm = frequency.replace(/^\s*Dostawa\s*/i, '').trim();

    if (quantityElement) quantityElement.textContent = `${quantity} ${worek} Pacha`;
    if (summaryElement) summaryElement.textContent = `${quantity} ${worek} \u017cwirku ${dostarczany} ${rytm}`;
}

form.addEventListener("change", updateFormDetails);

// Fonction pour mettre à jour le select Recharge en fonction du radio custom checked
function updateSelectFromRadio() {
    if (targetNode) {
      select = targetNode.querySelector('select[name="rc_selling_plan"]');
    }
    checkedRadio = radioContainer ? radioContainer.querySelector('input[type="radio"]:checked') : null;

    if (checkedRadio && select) {
        select.value = checkedRadio.value;
        let changeEvent = new Event('change', {
            bubbles: true,
            cancelable: true
        });
        // Déclenche l'événement "change" sur le select pour changer l'url avec le selling_plan (comportement normal de Recharge)
        select.dispatchEvent(changeEvent);
    }
}

if(quantityInput){
  radioContainer.addEventListener("change", updateSelectFromRadio);
}

let checkoutButton = document.querySelector('[checkout-button]');

if(checkoutButton) {
    checkoutButton.addEventListener('click', goCheckout);
}

function goCheckout(redirect = true) {
    checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');

    if (checkedRadio) {

        const quantityToSubmit = linkedProductsSelect ? 1 : quantity;

        let formData = {
            'items': [{
                id: currentProductId,
                quantity: quantityToSubmit,
                selling_plan: parseInt(checkedRadio.value)
            }]
        };

        return fetch(`/cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then(data => {
            if (redirect) {
                window.location.href = '/checkout';
            } else {
                return data;
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}

window.checkoutFunctions = window.checkoutFunctions ? {
    ...window.checkoutFunctions,
    productPageCheckoutFn: goCheckout,
} : {
    productPageCheckoutFn: goCheckout,
};

class ProductSelector extends HTMLElement{
    constructor(){
        super();

        this.select = this.querySelector('select');
    }

    connectedCallback(){
        this.setProductId();

        this.select.addEventListener('change', () => {
            this.setProductId();

            const activeOption = this.select.options[this.select.selectedIndex];
            this.setActiveFormRadios(activeOption.dataset.index);
        })

    }

    setProductId(){
        currentProductId = parseInt(this.select.value);
    }

    setActiveFormRadios(index){
        const allRadios = document.querySelectorAll('.custom-recharge-form-radios')

        allRadios.forEach(radio => {
            if(radio.dataset.index === index){
                radio.classList.remove('hidden');

                const radioInputs =  radio.querySelectorAll('input');

                radioInputs[1].checked = true;
            }
            else{
                radio.classList.add('hidden');
            }
        })
    }
}

customElements.define('product-selector', ProductSelector);